export type Platform = 'telegram' | 'vk' | 'max' | 'browser';

export function detectPlatform(): Platform {
  if (typeof window === 'undefined') return 'browser';
  const win = window as any;
  if (typeof win.Telegram?.WebApp?.initData === 'string' && win.Telegram.WebApp.initData.length > 0) return 'telegram';
  if (new URLSearchParams(window.location.search).has('vk_app_id')) return 'vk';
  if (typeof win.WebApp?.initData === 'string' && win.WebApp.initData.length > 0) return 'max';
  return 'browser';
}
